import React from "react";
import { Box } from "@mui/material";

export const CropOverlay = ({ width, height, isCircle }) => {
    return (
        <div
            style={{
                pointerEvents: "none",
                zIndex: 9999,
                position: "absolute",
                display: "inline-block",
                top: "50%",
                left: "50%",
                width: `${width}px`,
                height: `${height}px`,
                boxSizing: "border-box",
                transform: "translate(-50%, -50%)",
                border: isCircle ? "2px solid lightgray" : "2px solid #FFFFFF",
                borderRadius: isCircle ? "50%" : "0",
            }}
        >
            {!isCircle && (
                <>
                    {/* Edges */}
                    <Box position="absolute" top={-4} left="50%" width="50px" height="5px" sx={{ backgroundColor: "#FFFFFF", transform: "translateX(-50%)" }} />
                    <Box position="absolute" bottom={-4} left="50%" width="50px" height="5px" sx={{ backgroundColor: "#FFFFFF", transform: "translateX(-50%)" }} />
                    <Box position="absolute" left={-3.5} top="50%" width="5px" height="50px" sx={{ backgroundColor: "#FFFFFF", transform: "translateY(-50%)" }} />
                    <Box position="absolute" right={-3.5} top="50%" width="5px" height="50px" sx={{ backgroundColor: "#FFFFFF", transform: "translateY(-50%)" }} />

                    {/* Corners */}
                    {[
                        { top: -3.5, left: -3 },
                        { top: -3.5, right: -3 },
                        { bottom: -3.5, left: -3 },
                        { bottom: -3.5, right: -3 },
                    ].map((pos, idx) => (
                        <Box key={idx} position="absolute" width="50px" height="5px" sx={{ backgroundColor: "#FFFFFF", ...pos }} />
                    ))}

                    {[
                        { top: -3, left: -3.5 },
                        { top: -3, right: -3.5 },
                        { bottom: -3, left: -3.5 },
                        { bottom: -3, right: -3.5 },
                    ].map((pos, idx) => (
                        <Box key={idx + 4} position="absolute" width="5px" height="50px" sx={{ backgroundColor: "#FFFFFF", ...pos }} />
                    ))}
                </>
            )}
        </div>
    );
};
